document.addEventListener("DOMContentLoaded", () => {
  const cursor = document.querySelector(".cursor");
  if (!cursor) return;

  let targetX = 0;
  let targetY = 0;
  let currentX = 0;
  let currentY = 0;
  const speed = 0.15;
  let isVisible = false; 

  const handleFirstMove = (e) => {
    targetX = currentX = e.clientX;
    targetY = currentY = e.clientY;
    cursor.style.opacity = "1";

    document.removeEventListener("mousemove", handleFirstMove);
    document.addEventListener("mousemove", updateMousePosition);
  };

  const updateMousePosition = (e) => {
    targetX = e.clientX;
    targetY = e.clientY;
  };

  const animateCursor = () => {
    currentX += (targetX - currentX + 20) * speed;
    currentY += (targetY - currentY - 63) * speed;

    cursor.style.transform = `translate(${currentX}px, ${currentY}px)`;

    requestAnimationFrame(animateCursor);
  };

  document.addEventListener("mousemove", handleFirstMove);

  animateCursor();
});
